var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRetake(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4852 7.0012H14.7508C15.1664 7.0012 15.5008 6.66683 15.5008 6.2512V2.2512C15.5008 1.94808 15.3195 1.67308 15.0383 1.55745C14.757 1.44183 14.4352 1.50433 14.2195 1.71995L12.9195 3.01995C10.182 0.316825 5.77266 0.3262 3.05078 3.0512C0.316406 5.78558 0.316406 10.2168 3.05078 12.9512C5.78516 15.6856 10.2164 15.6856 12.9508 12.9512C13.3414 12.5606 13.3414 11.9262 12.9508 11.5356C12.5602 11.1449 11.9258 11.1449 11.5352 11.5356C9.58203 13.4887 6.41641 13.4887 4.46328 11.5356C2.51016 9.58245 2.51016 6.41683 4.46328 4.4637C6.40703 2.51995 9.54766 2.51058 11.5039 4.43245L10.2195 5.71995C10.0039 5.93558 9.94141 6.25745 10.057 6.5387C10.1727 6.81995 10.4477 7.0012 10.7508 7.0012H14.4852Z",
    fill: "#374151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRetake);
export default __webpack_public_path__ + "static/media/ic_retake.e93b967bcd30fe64466a935613b1f72d.svg";
export { ForwardRef as ReactComponent };